/**
 * Format currency in naira.
 *
 * @param {number} currency
 * @param {number} decimalPlaces
 */
export const currencyFormatter = (currency, decimalPlaces = 2) =>
  new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: decimalPlaces
  }).format(currency);

/**
 * Integer formatter.
 *
 * @param {integer} number
 * return :: 1000 = 1,000
 */
export const integerFormatter = (number) =>
  new Intl.NumberFormat().format(number);

/**
 * Time formatter.
 *
 * @param {integer} time
 * return :: 60 = 1:00
 */
export const formatTime = (time) => {
  // Hours, minutes and seconds
  var hrs = ~~(time / 3600);
  var mins = ~~((time % 3600) / 60);
  var secs = ~~time % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  var ret = '';
  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
  }
  ret += '' + mins + ':' + (secs < 10 ? '0' : '');
  ret += '' + secs;
  return ret;
};

/**
 * Capitalise string.
 *
 * @param {string}
 * return :: 
 */

export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
